import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@clearscore/rainbow.drawer';

import styles from './notifications-drawer.css';

const NotificationsDrawer = ({ children, onClose }) => (
    <Drawer
        isOpen={!!React.Children.count(children)}
        placement={Drawer.placements.RIGHT}
        onClose={onClose}
        onBackdropClick={onClose}
        theme={Drawer.themes.LIGHT}
        hasBackdrop
        dataId="notifications-drawer"
    >
        <div className={styles.content}>{children}</div>
    </Drawer>
);

NotificationsDrawer.propTypes = {
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
};

NotificationsDrawer.defaultProps = {
    children: null,
};

export default NotificationsDrawer;
